import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING, Regex } from '../../../../utils/appConstant';
import { AddEditApi } from '../../../../interfaces/developer.interface';
import { Validation } from '../../../../interfaces/common';

export const validateAddEditForm = (
  formData: AddEditApi,
  fieldName?: string
): Validation => {
  let validate = true;
  const fields = [];

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.name) {
    if (!formData.name || !formData.name.trim()) {
      validate = false;
      fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: APP_ERROR_MESSAGES.developers.addEdit.blankName
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      validate = false;
      fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.common.invalidEmail
      });
    }
  }

  if (!fieldName || fieldName === 'phone') {
    if (formData.phone && formData.phone.replace(/\s/g, '').length !== 10) {
      validate = false;
      fields.push({
        field: 'phone',
        message: APP_ERROR_MESSAGES.login.invalidPhoneNumber
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.website) {
    if (formData.website && !Regex.website.test(formData.website)) {
      validate = false;
      fields.push({
        field: VALIDATION_FIELD_MAPPING.website,
        message: APP_ERROR_MESSAGES.common.invalidUrl
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.countryId) {
    if (!formData.countryId) {
      validate = false;
      fields.push({
        field: VALIDATION_FIELD_MAPPING.countryId,
        message: APP_ERROR_MESSAGES.common.dropdown.notSelected
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.stateId) {
    if (!formData.stateId) {
      validate = false;
      fields.push({
        field: VALIDATION_FIELD_MAPPING.stateId,
        message: APP_ERROR_MESSAGES.common.dropdown.notSelected
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.cityId) {
    if (!formData.cityId) {
      validate = false;
      fields.push({
        field: VALIDATION_FIELD_MAPPING.cityId,
        message: APP_ERROR_MESSAGES.common.dropdown.notSelected
      });
    }
  }

  return { validate, fields };
};
